var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconCalendarNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m1 13 5.793-6.069L1.115 1",
  stroke: "#fff",
  strokeWidth: 1.2,
  strokeLinecap: "square"
})));

export default SvgIconCalendarNext;